import React, { useContext } from 'react'

import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import FormField from 'components/FormField'
import SoftButton from 'components/SoftButton'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import {
  createAssetForUser,
  createLiabilityForUser,
} from 'admin/utils/mutations'
import { IntakeContext } from 'context/IntakeContext'
import Slide from '@mui/material/Slide'
import { toast } from 'react-toastify'
import { useFinances } from 'hooks/useFinances'
import Checkbox from '@mui/material/Checkbox'
import { Box, Typography } from '@mui/material'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SelectInput = styled.select`
  display: flex;
  width: 100%;
  height: 2.5rem;
  font-size: 0.875rem;
  padding: 0 0.75rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid #d2d6da;
  color: #344767;
  letter-spacing: 0.00938em;
  font-family: Roboto;
  cursor: pointer;
  text-transform: capitalize;
  margin-top: 3px;
  &:active,
  &:focus,
  &:focus-visible {
    border-color: #17c1e8;
    box-shadow: 0 0 0 0.125rem rgba(129, 227, 249);
  }
`

export const BalanceSheetOnPageForm = ({
  handleClose,
  type,
  subType,
  name,
  amount,
  setSubType,
  setType,
  setName,
  setAmount,
  open,
  handleSubmit,
  typeSubTypeUuid,
  setKeepInRetirement,
  keepInRetirement,
  setMonthlyPayment,
  monthlyPayment,
  loanEndDate,
  setLoanEndDate,
  reloadAccounts,
  subTypeOptions = [],
  hideName,
  plaidName,
  componentHeader,
  updateTSPLoanToSubmit,
}) => {
  const { createOrUpdateAccount, deleteAccount } = useFinances()
  const onSubmit = async () => {
    console.log({
      name,
      amount,
      type,
      subType,
      typeSubTypeUuid,
      keepInRetirement,
      monthlyPayment,
      loanEndDate,
    })
    await createOrUpdateAccount({
      name,
      amount,
      type,
      subType,
      typeSubTypeUuid,
      keepInRetirement,
      monthlyPayment,
      loanEndDate,
    })
    toast.info(
      `You have successfully ${
        typeSubTypeUuid ? 'updated' : 'created'
      } a(n) ${type}`,
      {
        position: 'top-center',
        autoClose: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
    reloadAccounts()
    handleSubmit()
  }

  const onDelete = async () => {
    if (window.confirm('Are you sure?')) {
      await deleteAccount({ typeSubTypeUuid })
      toast.info(`You have successfully deleted account "${name}"`)
      reloadAccounts()
    }
    handleSubmit()
  }

  return (
    <>
      <Box sx={{ textAlign: 'left' }}>
        <Box mb={1}>
          <Typography variant="h4">{componentHeader}</Typography>
        </Box>
        <Typography variant="body1">
          Your Loan information will help us with your financial planning
        </Typography>
        <Box pt={3}>
          <Grid container>
            {/* Hidden Auto Type Selections */}
            <Grid item sx={{ display: 'none' }}>
              <SelectInput
                name="type"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="asset">Asset</option>
                <option value="liability">Liability</option>
              </SelectInput>
              <SelectInput
                name="subType"
                value={subType}
                onChange={(e) => setSubType(e.target.value)}
              >
                <option value="">Select Type</option>
                {subTypeOptions.map(({ value, label }) => {
                  return (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  )
                })}
              </SelectInput>
            </Grid>
            <Grid item xs={12} mb={2} sx={{ display: 'none' }}>
              {renderMuiFormField({
                inputType: 'text',
                placeholder: 'My TSP Loan',
                label: 'Nickname for this Loan',
                value: name,
                onChange: setName,
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              {renderMuiFormField({
                inputType: 'currencyFloat',
                placeholder: '$15,000',
                label: 'How much do you have remaining on this TSP Loan?',
                value: amount,
                onChange: (value) => {
                  setAmount(value)
                  updateTSPLoanToSubmit('amount', value)
                },
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              {renderMuiFormField({
                inputType: 'date',
                placeholder: '01/01/2030',
                label: 'When Do You Estimate Your TSP Loan Will Be Paid Off?',
                value: loanEndDate,
                onChange: (value) => {
                  setLoanEndDate(value)
                  updateTSPLoanToSubmit('loanEndDate', value)
                },
              })}
            </Grid>
            <Grid item xs={12} mb={3}>
              {renderMuiFormField({
                inputType: 'currencyFloat',
                placeholder: '$150.00',
                label: 'How Much Do You Pay Per Pay Period?',
                value: monthlyPayment,
                onChange: (value) => {
                  setMonthlyPayment(value)
                  updateTSPLoanToSubmit('monthlyPayment', value)
                },
              })}
            </Grid>
            <Grid item xs={12} sx={{ display: 'none' }}>
              <Button
                variant="contained"
                sx={[
                  {
                    fontSize: '15px',
                    padding: '10px 24px 9px',
                    backgroundColor: '#344767',
                    color: '#fff',
                    fontWeight: 'normal',
                    boxShadow: 'none',
                  },
                  {
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      transform: 'none',
                      backgroundColor: '#293852',
                      boxShadow: 'none',
                    },
                  },
                ]}
                onClick={onSubmit}
                data-testid="balanceSheetModalSaveButton"
              >
                Add This TSP Loan To Your Profile
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  )
}
